import { getTreeItemId } from './getTreeItemId';
import { goToComponent } from '../../../../../helpers/goToComponent';

export const goToTreeItem = (item: Parameters<typeof getTreeItemId>[0]) =>
  goToComponent(getTreeItemId(item));
